<div class="row col-12 p-0 m-0 main-page-section ">
    <!-- <div class="p-0">
              <app-side-nav [item]="meetingNav"></app-side-nav>
          </div> -->
    <div class="col-12 p-0 employee-section">
        <!-- <app-header></app-header> -->
        <div class="col-height">

            <div>

                <div class="breadcrumbs-section padding-left" *ngIf="!success">
                    <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
                    <img src="../../assets/images/seperator.png">
                    <span class="separator">&nbsp; &nbsp;</span>
                    <span class="prev-page pr-1 prev"><a routerLink="/companies/companies-list">Companies</a></span>
                    <span class="separator">&nbsp; </span>
                    <img src="../../assets/images/seperator.png">
                    <span class="curr-page pl-2 breadcrumbs-section-font current">Bulk-Upload</span>
                </div>

                <!-- <div class="breadcrumbs-section padding-left" *ngIf="success">
                    <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
                    <img src="../../assets/images/seperator.png">
                    <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/bulk-invite">Bulk-Upload</span>
                    <img src="../../assets/images/seperator.png">
                    <span class="curr-page pl-2 breadcrumbs-section-font current">Status</span>
                </div> -->

                <div class="bulk-layout">

                    <div class="row">
                        <div class="col-12">
                            <h1>Bulk Upload</h1>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-5 right-border">

                            <div class="row">
                                <div class="col-12">
                                    <p class="step mt-3">Step 1</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <h2>Enter Data</h2>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="text">We have created a format to help you input member card id data
                                        that
                                        will
                                        make it easier to
                                        upload
                                        information.
                                        Please download the below excel sheet to fill in your member card id data.</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="flex-column d-flex mt-3">
                                        <label>
                                            <a [attr.href]="templateUrl" download><img
                                                    src="../../assets/images/excel.png"><span
                                                    class="download pl-2">Download Excel Sheet here</span>
                                            </a>
                                            <!-- <a [attr.href]="templateUrl" (click)="downloadFile()" download><img
                                                    src="../../assets/images/excel.png"><span
                                                    class="download pl-2">Download Excel Sheet here</span>
                                            </a> -->
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-1 vertical-line"></div>


                        <div class="col-5 ml-0 pl-0">

                            <div class="row">
                                <div class="col-12">
                                    <p class="step mt-3">Step 2</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <h2>And Upload Here</h2>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-12">
                                    <div class="text">Once you have filled in your member card id data in the downloaded
                                        excel
                                        sheet, upload the
                                        document here.</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <input id="uploadfile-input" type="file"
                                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        (change)="handleFileSelect($event)" style="display: none;" />
                                    <label for="uploadfile-input">
                                        <span class="button"><img class="mr-1" src="../../assets/images/add-excel.png">
                                            Upload
                                            Excel
                                            Sheet here</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-1"></div>
                    </div>


                    <div *ngIf="success">
                        <hr class="ml-0 mt-3">
                        <div class="row mt-4">
                            <div class="col-1"><img class="success-icon" src="../../assets/images/green-tick.png"></div>
                            <div class="col-11 ml-0 pl-0">
                                <p class="sucess">Upload successful</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>